// in src/MyLayout.js
import * as React from 'react';
import { Layout } from 'react-admin';
import MyAppBar from './AppBar';
import { MyMenu } from "./Menu"

const MyLayout = (props) => <Layout className='custom-layout' style={{ paddingTop: "0px" }} {...props} menu={MyMenu} appBar={MyAppBar} />;

export default MyLayout;